export function Clipboard({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.54163 2.4165H11.4586C11.7294 2.41658 11.9764 2.511 12.1725 2.67334L12.2526 2.74658C12.4595 2.95354 12.5836 3.232 12.5836 3.5415C12.5836 4.16052 12.0776 4.66633 11.4586 4.6665H8.54163C8.27076 4.6665 8.0239 4.57198 7.82776 4.40967L7.7467 4.33643C7.53975 4.12947 7.41663 3.85101 7.41663 3.5415C7.41663 2.92238 7.92251 2.4165 8.54163 2.4165Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M15.6917 4.19127C15.5 4.03294 15.2834 3.90794 15.05 3.81627C14.8084 3.7246 14.5667 3.91627 14.5167 4.16627C14.2334 5.59127 12.975 6.66627 11.4584 6.66627H8.54171C7.70837 6.66627 6.92504 6.34127 6.33337 5.7496C5.90004 5.31627 5.60004 4.76627 5.48337 4.1746C5.43337 3.9246 5.18337 3.7246 4.94171 3.8246C3.97504 4.21627 3.33337 5.0996 3.33337 6.8746V14.9996C3.33337 17.4996 4.82504 18.3329 6.66671 18.3329H13.3334C15.175 18.3329 16.6667 17.4996 16.6667 14.9996V6.8746C16.6667 5.51627 16.2917 4.68294 15.6917 4.19127ZM6.66671 10.2079H10C10.3417 10.2079 10.625 10.4913 10.625 10.8329C10.625 11.1746 10.3417 11.4579 10 11.4579H6.66671C6.32504 11.4579 6.04171 11.1746 6.04171 10.8329C6.04171 10.4913 6.32504 10.2079 6.66671 10.2079ZM13.3334 14.7913H6.66671C6.32504 14.7913 6.04171 14.5079 6.04171 14.1663C6.04171 13.8246 6.32504 13.5413 6.66671 13.5413H13.3334C13.675 13.5413 13.9584 13.8246 13.9584 14.1663C13.9584 14.5079 13.675 14.7913 13.3334 14.7913Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
}
